import React from 'react'

const Proforma = () => {
  return (
    <div>Proforma</div>
  )
}

export default Proforma